import { AuthenticationState } from './types'

export const state: AuthenticationState = {
  loggedInUser: {
    firstName: '',
    lastName: '',
    userIdentifier: '',
  },
}
